<div class="thank-you-wrapper" fxLayout="row" fxFlex="" fxLayoutAlign="center" >
  <div class="thank-you-container" fxFlex="60" fxFlexAlign=" center">
    <h1>{{ 'THANK_YOU.TITLE' | translate }}</h1>
    <h4>{{ 'THANK_YOU.CAN_LOGIN' | translate }}</h4>
    <span>
      {{ 'THANK_YOU.GO_TO_LOGIN' | translate }} <a routerLink="/">{{ 'THANK_YOU.CLICK_HERE' | translate }}</a>
    </span>
  </div>
</div>
